import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const TrashIcon = forwardRef<SVGSVGElement, IconProps>(function LockIcon(
  { color = '', height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.47437 2.95069L5.63215 1.99068L5.64231 1.92809C5.69698 1.58878 5.78356 1.05141 6.13623 0.64278C6.5537 0.15906 7.18195 0 7.94129 0H10.0584C10.8287 0 11.4558 0.172551 11.8704 0.660661C12.223 1.07586 12.3073 1.61419 12.3596 1.94808L12.3678 2.00026L12.5322 2.99278C13.805 3.06218 15.0765 3.1615 16.3444 3.28988C16.7441 3.33035 17.036 3.69425 16.9964 4.10266C16.9568 4.51107 16.6007 4.80934 16.201 4.76887C13.5332 4.49874 10.8501 4.35965 8.17576 4.35965C6.60031 4.35965 5.02471 4.44095 3.44888 4.60359L3.44676 4.60381L1.79828 4.76895C1.39854 4.80899 1.04271 4.51034 1.00352 4.10188C0.964332 3.69343 1.25662 3.32985 1.65636 3.2898L3.30378 3.12477C4.02726 3.05012 4.7508 2.99209 5.47437 2.95069ZM6.9594 2.88908L7.06654 2.23718C7.10065 2.03026 7.12411 1.89475 7.15711 1.78257C7.18755 1.67905 7.21434 1.64064 7.22745 1.62546C7.23511 1.61631 7.34405 1.48624 7.94129 1.48624H10.0584C10.6468 1.48624 10.7598 1.62054 10.7718 1.63475C10.8236 1.69573 10.8636 1.80925 10.9325 2.2416L11.0458 2.92541C10.0889 2.89087 9.13188 2.87341 8.17576 2.87341C7.7703 2.87341 7.36484 2.87864 6.9594 2.88908Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5821 5.89698C14.9829 5.92342 15.2869 6.27686 15.261 6.68642L14.7355 15.0052L14.7342 15.0242C14.7131 15.3325 14.6892 15.681 14.625 16.0068C14.5579 16.3469 14.4381 16.7149 14.1908 17.0438C13.6701 17.7366 12.7944 18 11.5939 18H6.40602C5.20548 18 4.32979 17.7366 3.80906 17.0438C3.56177 16.7149 3.44195 16.3469 3.3749 16.0068C3.31068 15.681 3.28681 15.3325 3.26569 15.0242L3.26438 15.0052L3.26411 15.0011L2.73887 6.68642C2.71299 6.27686 3.01695 5.92342 3.41778 5.89698C3.8186 5.87054 4.16451 6.18113 4.19038 6.59069L4.71536 14.9013L4.7155 14.9033C4.73842 15.2375 4.75734 15.4928 4.8008 15.7133C4.84285 15.9266 4.89878 16.0536 4.9626 16.1385C5.06409 16.2735 5.35203 16.5138 6.40602 16.5138H11.5939C12.6479 16.5138 12.9358 16.2735 13.0373 16.1385C13.1011 16.0536 13.157 15.9266 13.1991 15.7133C13.2425 15.4928 13.2615 15.2375 13.2844 14.9033L13.2845 14.9013L13.8095 6.59069C13.8354 6.18113 14.1813 5.87054 14.5821 5.89698Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.92315 12.7156C6.92315 12.3052 7.24876 11.9725 7.65042 11.9725H10.3413C10.743 11.9725 11.0686 12.3052 11.0686 12.7156C11.0686 13.126 10.743 13.4587 10.3413 13.4587H7.65042C7.24876 13.4587 6.92315 13.126 6.92315 12.7156Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25253 9.41288C6.25253 9.00246 6.57814 8.66976 6.97979 8.66976H11.0202C11.4218 8.66976 11.7474 9.00246 11.7474 9.41288C11.7474 9.82329 11.4218 10.156 11.0202 10.156H6.97979C6.57814 10.156 6.25253 9.82329 6.25253 9.41288Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
